import React from 'react'
import VideoSlide from './video-slide'

const Slide = ({ slide, active = false, onVideoPlay, onVideoPause, onVideoEnded }) => {
  // Video slides aren't wrapped in a link so clicks reach the player.
  if (slide.video) {
    return (
      <VideoSlide
        slide={slide}
        active={active}
        onPlay={onVideoPlay}
        onPause={onVideoPause}
        onEnded={onVideoEnded}
      />
    )
  }

  // default slide type
  const slideContent = (
    <div className={`w-full text-white relative`}>
      <img
        src={slide.image || 'https://placehold.co/1280x720/ddd/ddd'}
        alt={slide.title}
        className='w-full sm:aspect-[16/9] object-cover block'
      />

      <div
        className={`hidden sm:block absolute left-0 ${slide.title_position?.trim() || 'bottom-0'} w-full p-2 sm:p-3 pointer-events-none z-10`}
      >
        <div className='bg-black text-white p-2 sm:p-3 rounded  flex flex-col opacity-65'>
          <div className='flex flex-col sm:flex-row sm:items-baseline sm:justify-between w-full'>
            <div className='font-serif text-xl'>{slide.title}</div>
            {slide.top_line && (
              <div
                className='text-sm'
                dangerouslySetInnerHTML={{ __html: slide.top_line }}
              />
            )}
          </div>
          {slide.summary && (
            <div
              className='text-sm hidden sm:block'
              dangerouslySetInnerHTML={{ __html: slide.summary }}
            />
          )}
        </div>
      </div>
      {slide.certificate && (
        <div
          className={`absolute ${slide.certificate_class?.trim() || 'top-0 right-0'} w-10 h-10 sm:w-15 sm:h-15 p-2 sm:p-3 pointer-events-none z-10`}
        >
          <img src={slide.certificate.image} alt={slide.certificate.name} />
        </div>
      )}
      <div className='sm:hidden rounded-b bg-white dark:bg-black text-black dark:text-white p-2 flex flex-col items-center pointer-events-none'>
        <div className='font-serif'>{slide.title}</div>
        <div
          className='text-sm'
          dangerouslySetInnerHTML={{ __html: slide.top_line }}
        />
      </div>
    </div>
  )

  // Wrap in link if URL is provided
  if (slide.url) {
    return (
      <a href={slide.url} className='block w-full h-full cursor-pointer'>
        {slideContent}
      </a>
    )
  }

  return slideContent
}

export default Slide
